import { render, staticRenderFns } from "./TechnologyCard.vue?vue&type=template&id=3c6147dc&scoped=true&"
import script from "./TechnologyCard.vue?vue&type=script&lang=js&"
export * from "./TechnologyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6147dc",
  null
  
)

export default component.exports